import React from 'react';
import {Typography} from "antd";
import PropTypes from "prop-types";

const MyText = ({center, uppercase, medium, black, strong, stronger, italic, size, children, ...rest}) => {
    const style = {
        ...(center && {textAlign: "center"}),
        ...(uppercase && { textTransform: "uppercase" }),
        ...(medium && { fontWeight: "400" }),
        ...(black && { fontWeight: "600" }),
        ...(strong && { fontWeight: "700" }),
        ...(stronger && { fontWeight: "800" }),
        ...(italic && { fontStyle: "italic" }),
        ...(size === "small" && { fontSize: "0.85rem" }),
        ...(size === "default" && { fontSize: "1rem" }),
        ...(size === "big" && { fontSize: "1.1rem" }),
        ...(size === "bigger" && { fontSize: "1.25rem" }),
        ...(size === "large" && { fontSize: "1.5rem" }),
        ...(size === "larger" && { fontSize: "2rem" }),
        ...(size === "x-large" && { fontSize: "2.5rem" }),
        ...(!size && { fontSize: "1rem" }),
        ...rest.style
    };

    return (
        <p {...rest} style={style}>
            {children}
        </p>
    );
};
MyText.propTypes = {
    ...Typography.Text.propTypes,
    center: PropTypes.bool,
    uppercase: PropTypes.bool,
    medium: PropTypes.bool,
    black: PropTypes.bool,
    strong: PropTypes.bool,
    stronger: PropTypes.bool,
    italic: PropTypes.bool,
    size: PropTypes.oneOf(['small', 'default', 'big', 'bigger', 'large', 'larger', 'x-large']),
    children: PropTypes.node,
};

export default MyText;